// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"authform_wrapper__3U4FE","input":"authform_input__34LYd","row":"authform_row__2C8Ot","center":"authform_center__1ZQSn","legal":"authform_legal__33IBO"};